import React from 'react';
import styled from '../../styled';
import { COLORS } from '../../themes/color';

type BadgeVariant = 'filled' | 'tinted' | 'outlined';

const Badge = styled('span')<{ badgeVariant: BadgeVariant }>`
  display: inline-block;
  background-color: ${(p) =>
    p.badgeVariant === 'filled'
      ? COLORS.PRIMARY
      : p.badgeVariant === 'tinted'
      ? '#e6f7ff'
      : 'transparent'};
  color: ${(p) => (p.badgeVariant === 'filled' ? 'white' : COLORS.PRIMARY)};
  border: ${(p) =>
    p.badgeVariant === 'outlined' ? `1px solid ${COLORS.PRIMARY}` : 'none'};
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 4px;
  width: fit-content;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
`;

const NeutralBadge = styled(Badge)`
  background-color: transparent;
  color: #64748b;
  border: 1px solid #cbd5e1;
`;

export const NewBadge = ({
  children = 'New'
}: {
  children?: React.ReactNode;
}) => {
  return <Badge badgeVariant="filled">{children}</Badge>;
};

export const EarlyAccessBadge = ({
  children = 'Early access'
}: {
  children?: React.ReactNode;
}) => {
  return <Badge badgeVariant="filled">{children}</Badge>;
};

export const NoCodeBadge = ({
  children = 'No code'
}: {
  children?: React.ReactNode;
}) => {
  return <Badge badgeVariant="tinted">{children}</Badge>;
};

export const ComingSoonBadge = ({
  children = 'Coming soon'
}: {
  children?: React.ReactNode;
}) => {
  return <NeutralBadge badgeVariant="outlined">{children}</NeutralBadge>;
};
